import './subscription.scss'
// import clsx from 'clsx'
import {
    // Button,
    ContentContainer,
    Heading,
    LoadingIndicator,
    // RoundRadio,
} from '@/shared/ui'
// import { subscribe } from '@/shared/cloud-payments/subscribe'
// import { useSubscriptionStore } from '../model/store'
import {
    ReactNode,
    // useEffect,
    useState,
} from 'react'

import classes from './Subscription.module.scss'
import {
    useActiveWorkspace,
    NormalSubscription,
} from '@/true-fsd/data/advertiser-account'
// import { MaxFailedTransactions } from '@synapex/shared/src/utils/cloudpayments/constants'

// const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL

const NormalSubscriptionView = (props: NormalSubscription) => {
    switch (props.status) {
        case 'trial':
            return `Пробная версия(осталось ${props.daysLeft} дней)`
        default:
            return `Пробный период закончился. Необходимо оплатить подписку на сервис`
    }
}

export type SubscriptionProps = {
    // channelId: number
}
export const Subscription = (
    {
        // channelId
    }: SubscriptionProps
) => {
    // const user = useUserWorkspaceStoreIs((state) => state.user)
    const { subscription, activeWorkspace } = useActiveWorkspace()

    // const {
    //     // selectedPlan,
    //     subscriptionPlans,
    //     fetchSubscriptionPlans,
    //     // selectPlan,
    // } = useSubscriptionStore()

    const [
        loading,
        //  setLoading
    ] = useState(false)

    // const handlePaymentSuccess = () => {
    //     fetchChannelSubscriptionStatuses(channelId)
    // }

    // const handlePayment = () => {
    //     if (!selectedPlan) return
    //     if (channelId) {
    //         console.log(
    //             'selectedPlan',
    //             selectedPlan,
    //             selectedPlan.maxPeriods,
    //             selectedPlan.maxPeriods || 0
    //         )
    //         subscribe(
    //             {
    //                 price: selectedPlan.price,
    //                 quantity: 1,
    //                 channelId: channelId,
    //                 invoiceId: `sub-${Date.now()}`,
    //                 userId: user?.user_id || 0,
    //                 interval: selectedPlan.interval || 'Month',
    //                 period: selectedPlan.period || 1,
    //                 // maxPeriods: selectedPlan.maxPeriods || 0,
    //             },
    //             currentSubscriptionStatus!, // I'm sure that it's not null
    //             FRONTEND_URL,
    //             () => {
    //                 setLoading(true)
    //             },
    //             () => {
    //                 handlePaymentSuccess()
    //                 setLoading(false)
    //             }
    //         )
    //     }
    // }

    // const handleSelectedPlan = (planId: string) => {
    //     selectPlan(parseInt(planId))
    // }

    // const isSubscribed =
    //     channelId &&
    //     (currentSubscriptionStatus?.status === SubscriptionStatusEnum.Failed ||
    //         currentSubscriptionStatus?.status === SubscriptionStatusEnum.Active)
    // const hasSubscriptionPlan = currentSubscriptionStatus?.subscriptionPlan

    // const isPlanDisabled = (planId: number) => {
    //     return (
    //         isSubscribed &&
    //         hasSubscriptionPlan &&
    //         planId !== currentSubscriptionStatus?.subscriptionPlan?.id
    //     )
    // }

    let subscriptionInfoText: ReactNode
    switch (subscription.status) {
        case 'superuser':
            subscriptionInfoText = (
                <div>
                    Вы суперюзер, ограничения подписки на вас не действуют.
                    <br />
                    Статус подписки владельца{' '}
                    {activeWorkspace.advertiser_account_id
                        ? 'аккаунта'
                        : activeWorkspace.workspace_type === 'site'
                          ? 'сайта'
                          : 'канала'}
                    :<br />
                    <NormalSubscriptionView {...subscription.actual_owner} />
                </div>
            )
            break

        default:
            subscriptionInfoText = <NormalSubscriptionView {...subscription} />
    }

    return (
        <div className="subscription">
            {loading && (
                <div className="loading-overlay">
                    <LoadingIndicator
                        style={{ width: '80px', height: '80px' }}
                    />
                </div>
            )}

            <ContentContainer className="subscription__container-one">
                {/* <Heading className="heading1">Выберите тарифный план</Heading> */}
                <div className={classes.text}>
                    Тарифные планы на сайте{' '}
                    <a href="https://synapex.cloud">synapex.cloud</a>. Для оплаты
                    напишите в поддержку
                </div>
                {/* <div className="subscription__plans">
                    {subscriptionPlans.map((plan) => {
                        const disabled = isPlanDisabled(plan.id)
                        return (
                            <div
                                key={plan.id}
                                className={clsx('subscription__plans__plan', {
                                    active: isSubscribed
                                        ? currentSubscriptionStatus
                                              ?.subscriptionPlan.id === plan.id
                                        : selectedPlan?.id === plan.id,
                                    disabled,
                                })}
                                onClick={() =>
                                    !disabled &&
                                    handleSelectedPlan(plan.id.toString())
                                }
                            >
                                <RoundRadio
                                    id={plan.id.toString()}
                                    name="subscriptionPlan"
                                    value={plan.id.toString()}
                                    checked={
                                        isSubscribed
                                            ? currentSubscriptionStatus
                                                  ?.subscriptionPlan.id ===
                                              plan.id
                                            : selectedPlan?.id === plan.id
                                    }
                                    onChange={handleSelectedPlan}
                                    disabled={!!disabled}
                                />
                                <div className="subscription__plans__plan__box-one">
                                    <div className="plan-duration">
                                        {plan.duration}
                                    </div>
                                    {plan.promotion && (
                                        <div className="plan-promotion">
                                            {plan.promotion}
                                        </div>
                                    )}
                                </div>
                                <div
                                    className={`subscription__plans__plan__box-two ${plan.period > 1 ? 'discounted' : ''}`}
                                >
                                    <div className="price">
                                        {plan.price / plan.period} ₽
                                    </div>
                                    {plan.period > 1 && (
                                        <div className="total-price">
                                            всего {plan.price} ₽
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <Button
                    disabled={
                        channelId
                            ? !currentSubscriptionStatus?.owner ||
                              currentSubscriptionStatus.status ===
                                  SubscriptionStatusEnum.Active ||
                              !(
                                  currentSubscriptionStatus.status ===
                                      SubscriptionStatusEnum.Trial ||
                                  currentSubscriptionStatus.status ===
                                      SubscriptionStatusEnum.Failed ||
                                  currentSubscriptionStatus.status ===
                                      SubscriptionStatusEnum.Expired ||
                                  currentSubscriptionStatus.status ===
                                      SubscriptionStatusEnum.NotSubscribed
                              )
                            : true
                    }
                    size="fit"
                    className="button-size"
                    onClick={handlePayment}
                >
                    {currentSubscriptionStatus?.status ===
                    SubscriptionStatusEnum.Failed
                        ? `Оплатить (${MaxFailedTransactions - currentSubscriptionStatus.failedTransactionCount})`
                        : 'Оплатить'}
                </Button>

                <div className="footer">
                    Оплачивая подписку на сервис Synapex, вы соглашаетесь с{' '}
                    <span className="underline">Договором-Офертой</span> ООО
                    “Синапекс”
                </div> */}
            </ContentContainer>

            <ContentContainer className="subscription__container-two">
                <Heading className="heading2">Подписка</Heading>
                <p className="subscription__container-two__due-date">
                    {subscriptionInfoText}
                </p>
            </ContentContainer>
        </div>
    )
}
